
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1409Dialog extends Serenity.EntityDialog<Report_1409Row, any> {
        protected getFormKey() { return Report_1409Form.formKey; }
        protected getIdProperty() { return Report_1409Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1409Row.localTextPrefix; }
        protected getNameProperty() { return Report_1409Row.nameProperty; }
        protected getService() { return Report_1409Service.baseUrl; }
        protected getDeletePermission() { return Report_1409Row.deletePermission; }
        protected getInsertPermission() { return Report_1409Row.insertPermission; }
        protected getUpdatePermission() { return Report_1409Row.updatePermission; }

        protected form = new Report_1409Form(this.idPrefix);

    }
}